module.exports = __webpack_public_path__ + "static/moa-graphic-desktop_rev2-dc2294e978511e343b35104eb0add09b.png";